import "../OperazioniHr/OperazioniHr.css"

import FiltroCategorie from "../../components/FiltroCategorie/FiltroCategorie";
import MonthPickerModal from "../../components/MonthPickerModal/MonthPickerModal";
import Trend from "./Trend/Trend";
import TrendKpi from "./TrendKpi/TrendKpi";
import DettaglioAttivi from "./DettaglioAttivi/DettaglioAttivi";
import TrendEntrateUscite from "./TrendEntrateUscite/TrendEntrateUscite";

import { useState, useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Select, { components } from "react-select";
import { MOCKED_HR_GENERALE_CATEGORIES } from "../../mocks/MockedCategories";

// Componente custom per mostrare numero elementi selezionati nei Select multi
const MultiValueContainer = ({ children, selectProps, data, ...props }) => {
    const values = selectProps.value || [];
    const index = values.findIndex(v => v.value === data.value);

    if (index < 2) {
        return <components.MultiValue selectProps={selectProps} data={data} {...props}>{children}</components.MultiValue>;
    }
    if (index === 2 && values.length > 2) {
        return (
            <div className="oper-hr-select-more-badge">
                +{values.length - 2}
            </div>
        );
    }
    return null;
};

// Helper per date
const formatDate = (date) => {
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, "0");
    const d = String(date.getDate()).padStart(2, "0");
    return `${y}-${m}-${d}`;
};

const monthToFirstDay = (monthValue) => {
    if (!monthValue) return '';
    const [year, month] = monthValue.split('-');
    return `${year}-${month}-01`;
};

const monthToLastDay = (monthValue) => {
    if (!monthValue) return '';
    const [year, month] = monthValue.split('-');
    const lastDay = new Date(parseInt(year), parseInt(month), 0).getDate();
    return `${year}-${month}-${String(lastDay).padStart(2, '0')}`;
};

const dateToMonth = (dateValue) => {
    if (!dateValue) return '';
    const [year, month] = dateValue.split('-');
    return `${year}-${month}`;
};

const getDefaultDateRange = () => {
    const today = new Date();
    const lastDayCurrentMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    const firstDay12MonthsAgo = new Date(today.getFullYear(), today.getMonth() - 11, 1);
    return {
        from: formatDate(firstDay12MonthsAgo),
        to: formatDate(lastDayCurrentMonth),
    };
};

const defaultDates = getDefaultDateRange();

export const HrGenerale = () => {
    const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001/api";
    const navigate = useNavigate();

    const [showInfoModal, setShowInfoModal] = useState(false);
    const [showFiltersPanel, setShowFiltersPanel] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [loading, setLoading] = useState(false);

    const [fromDate, setFromDate] = useState(defaultDates.from);
    const [toDate, setToDate] = useState(defaultDates.to);
    const [selectedSettore, setSelectedSettore] = useState([]);
    const [selectedTipoContratto, setSelectedTipoContratto] = useState([]);
    const [selectedCcnl, setSelectedCcnl] = useState([]);
    const [selectedMotivoCessazione, setSelectedMotivoCessazione] = useState([]);

    const [appliedFilters, setAppliedFilters] = useState({
        fromDate: defaultDates.from,
        toDate: defaultDates.to,
        settore: [],
        tipoContratto: [],
        ccnl: [],
        motivoCessazione: []
    });

    const [filterOptions, setFilterOptions] = useState({
        settore: [],
        tipoContratto: [],
        ccnl: [],
        motivoCessazione: []
    });

    // Handler per i campi mese
    const handleFromMonthChange = (e) => {
        const monthValue = e.target.value;
        setFromDate(monthToFirstDay(monthValue));
    };

    const handleToMonthChange = (e) => {
        const monthValue = e.target.value;
        setToDate(monthToLastDay(monthValue));
    };

    const handleApply = useCallback(() => {
        setAppliedFilters({
            fromDate,
            toDate,
            settore: selectedSettore,
            tipoContratto: selectedTipoContratto,
            ccnl: selectedCcnl,
            motivoCessazione: selectedMotivoCessazione
        });
    }, [fromDate, toDate, selectedSettore, selectedTipoContratto, selectedCcnl, selectedMotivoCessazione]);

    const handleReset = useCallback(() => {
        setFromDate(defaultDates.from);
        setToDate(defaultDates.to);
        setSelectedSettore([]);
        setSelectedTipoContratto([]);
        setSelectedCcnl([]);
        setSelectedMotivoCessazione([]);
        setAppliedFilters({
            fromDate: defaultDates.from,
            toDate: defaultDates.to,
            settore: [],
            tipoContratto: [],
            ccnl: [],
            motivoCessazione: []
        });
    }, []);

    // opzioni dei dropdown dal backend al mount del componente
    useEffect(() => {
        const fetchFilters = async () => {
            try {
                const res = await axios.get(`${API_URL}/hr-generale/filters`);
                setFilterOptions({
                    settore: res.data.settore.map(s => ({ value: s.id, label: s.valore })),
                    tipoContratto: res.data.tipoContratto.map(tc => ({ value: tc.id, label: tc.valore })),
                    ccnl: res.data.ccnl.map(c => ({ value: c.id, label: c.valore })),
                    motivoCessazione: res.data.motivoCessazione.map(m => ({ value: m.id, label: m.valore }))
                });
            } catch (error) {
                console.error("Errore nel caricamento dei filtri:", error);
            }
        };
        fetchFilters();
    }, [API_URL]);

    return (
        <div className="operazioni-hr-page">
            <header className="oper-hr-header">
                <div className="oper-hr-header-content">
                    <button className="oper-hr-back-btn" onClick={() => navigate('/reportistica')}>
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polyline points="15 18 9 12 15 6"></polyline>
                        </svg>
                        Indietro
                    </button>

                    <div className="oper-hr-header-title">
                        <div className="oper-hr-title-row">
                            <h1>HR Generale</h1>
                            <button className="oper-hr-info-btn" onClick={() => setShowInfoModal(true)} title="Informazioni">
                                <span>i</span>
                            </button>
                        </div>
                        <p className="oper-hr-subtitle">Trend e analisi generale risorse umane</p>
                    </div>
                </div>
            </header>

            {/* Modal Info */}
            {showInfoModal && (
                <div className="oper-hr-modal-overlay" onClick={() => setShowInfoModal(false)}>
                    <div className="oper-hr-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="oper-hr-modal-header">
                            <div className="oper-hr-modal-icon">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <line x1="12" y1="16" x2="12" y2="12"></line>
                                    <line x1="12" y1="8" x2="12.01" y2="8"></line>
                                </svg>
                            </div>
                            <h3>Informazioni sulla pagina</h3>
                            <button className="oper-hr-modal-close" onClick={() => setShowInfoModal(false)}>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <line x1="18" y1="6" x2="6" y2="18"></line>
                                    <line x1="6" y1="6" x2="18" y2="18"></line>
                                </svg>
                            </button>
                        </div>
                        <div className="oper-hr-modal-body">
                            <div className="oper-hr-modal-section">
                                <h4>Cosa fa questa pagina?</h4>
                                <p>
                                    Questa pagina permette di analizzare i trend generali HR:
                                    andamento ingressi e uscite, numero dipendenti attivi nel tempo,
                                    indicatori di performance e dettaglio delle risorse.
                                </p>
                            </div>
                            <div className="oper-hr-modal-section">
                                <h4>Come utilizzarla?</h4>
                                <ul>
                                    <li><strong>Filtri:</strong> Applica filtri per periodo (mese inizio/fine), settore, tipo contratto, CCNL e motivo cessazione</li>
                                    <li><strong>Trend:</strong> Visualizza l'andamento del numero di dipendenti attivi nel tempo</li>
                                    <li><strong>Trend KPI:</strong> Monitora gli indicatori chiave di performance HR con grafici interattivi</li>
                                    <li><strong>Trend Entrate/Uscite:</strong> Analizza il flusso di ingressi e cessazioni nel periodo selezionato</li>
                                    <li><strong>Dettaglio Attivi:</strong> Consulta il dettaglio delle risorse attualmente attive con informazioni anagrafiche e contrattuali</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <main className="oper-hr-main">

                {/* Bottone Mostra Filtri */}
                <div className="oper-hr-actions">
                    <button
                        type="button"
                        className={`oper-hr-action-btn ${showFiltersPanel ? 'active' : ''}`}
                        onClick={() => setShowFiltersPanel(prev => !prev)}
                    >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>
                        </svg>
                        <span>{showFiltersPanel ? 'Nascondi Filtri' : 'Mostra Filtri'}</span>
                    </button>
                </div>

                {/* Pannello Filtri */}
                {showFiltersPanel && (
                    <div className="oper-hr-panel">
                        <div className="oper-hr-filters-grid">
                            <div className="oper-hr-filter-item">
                                <label>Mese Inizio</label>
                                <MonthPickerModal
                                    value={dateToMonth(fromDate)}
                                    onChange={handleFromMonthChange}
                                    max={dateToMonth(toDate) || undefined}
                                    label="Mese Inizio"
                                />
                            </div>

                            <div className="oper-hr-filter-item">
                                <label>Mese Fine</label>
                                <MonthPickerModal
                                    value={dateToMonth(toDate)}
                                    onChange={handleToMonthChange}
                                    min={dateToMonth(fromDate) || undefined}
                                    label="Mese Fine"
                                />
                            </div>

                            <div className="oper-hr-filter-item">
                                <label>Settore</label>
                                <Select
                                    classNamePrefix="oper-hr-select"
                                    placeholder="Tutte"
                                    value={selectedSettore}
                                    options={filterOptions.settore}
                                    onChange={setSelectedSettore}
                                    isMulti
                                    components={{ MultiValue: MultiValueContainer }}
                                    hideSelectedOptions={false}
                                    closeMenuOnSelect={false}
                                />
                            </div>

                            <div className="oper-hr-filter-item">
                                <label>Tipo Contratto</label>
                                <Select
                                    classNamePrefix="oper-hr-select"
                                    placeholder="Tutte"
                                    value={selectedTipoContratto}
                                    options={filterOptions.tipoContratto}
                                    onChange={setSelectedTipoContratto}
                                    isMulti
                                    components={{ MultiValue: MultiValueContainer }}
                                    hideSelectedOptions={false}
                                    closeMenuOnSelect={false}
                                />
                            </div>

                            <div className="oper-hr-filter-item">
                                <label>CCNL</label>
                                <Select
                                    classNamePrefix="oper-hr-select"
                                    placeholder="Tutte"
                                    value={selectedCcnl}
                                    options={filterOptions.ccnl}
                                    onChange={setSelectedCcnl}
                                    isMulti
                                    components={{ MultiValue: MultiValueContainer }}
                                    hideSelectedOptions={false}
                                    closeMenuOnSelect={false}
                                />
                            </div>

                            <div className="oper-hr-filter-item">
                                <label>Motivo Cessazione</label>
                                <Select
                                    classNamePrefix="oper-hr-select"
                                    placeholder="Tutte"
                                    value={selectedMotivoCessazione}
                                    options={filterOptions.motivoCessazione}
                                    onChange={setSelectedMotivoCessazione}
                                    isMulti
                                    components={{ MultiValue: MultiValueContainer }}
                                    hideSelectedOptions={false}
                                    closeMenuOnSelect={false}
                                />
                            </div>

                            <div className="oper-hr-filter-actions">
                                <button type="button" className="oper-hr-btn-primary" onClick={handleApply}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <polyline points="20 6 9 17 4 12"></polyline>
                                    </svg>
                                    Applica
                                </button>
                                <button type="button" className="oper-hr-btn-secondary" onClick={handleReset}>
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                                        <path d="M3 3v5h5"></path>
                                    </svg>
                                    Reset
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Tab + Contenuto */}
                <div className="oper-hr-data-section">
                    <FiltroCategorie
                        categories={MOCKED_HR_GENERALE_CATEGORIES}
                        filteredCategory={setSelectedCategory}
                        customCss={"reportistica-section"}
                    />

                    {selectedCategory === "Trend" && (
                        <Trend filters={appliedFilters} loading={loading} />
                    )}
                    {selectedCategory === "Trend KPI" && (
                        <TrendKpi filters={appliedFilters} loading={loading} />
                    )}
                    {selectedCategory === "Trend Entrate/Uscite" && (
                        <TrendEntrateUscite filters={appliedFilters} loading={loading} />
                    )}
                    {selectedCategory === "Dettaglio Attivi" && (
                        <DettaglioAttivi filters={appliedFilters} loading={loading} />
                    )}
                </div>
            </main>
        </div>
    )
}

export default HrGenerale;



